<template>
  <v-layout wrap>
    <v-flex xs12 pb-0>
      <v-layout wrap align-center>
        <v-flex xs12 mt-3>
          <h1 class="headline mb-4">
            {{ $t('auto.internalMaintenance') }} - {{ autoTitle }}
          </h1>
        </v-flex>
      </v-layout>
    </v-flex>

    <v-flex xs12 mt-4>
      <v-simple-table>
        <thead class="v-data-table-header">
          <tr>
            <th v-for="(header, key) in headers" :key="key">
              {{ header.text }}
            </th>
          </tr>
        </thead>

        <tbody>
          <tr>
            <td>
              <b>{{ $t('auto.internalMaintenance.oilChange') }}</b>
            </td>
            <td>
              <button
                class="edit-btn"
                :disabled="editDisabled"
                @click="
                  () => {
                    dateDialog.opened = true;
                    dateDialog.currentValue = tableData.oil_change_date;
                    dateDialog.paramName = 'oil_change_date';
                  }
                "
              >
                {{ tableData.oil_change_date || '—' }}
              </button>
            </td>
            <td :class="getExpireStateColor(tableData.oil_change_next_days)">
              {{ tableData.oil_change_next_date || '—' }}
            </td>
          </tr>
          <tr>
            <td>
              <b>{{ $t('auto.internalMaintenance.brakeReplacement') }}</b>
            </td>
            <td>
              <button
                class="edit-btn"
                :disabled="editDisabled"
                @click="
                  () => {
                    dateDialog.opened = true;
                    dateDialog.currentValue = tableData.brake_pads_change_date;
                    dateDialog.paramName = 'brake_pads_change_date';
                  }
                "
              >
                {{ tableData.brake_pads_change_date || '—' }}
              </button>
            </td>
            <td
              :class="
                getExpireStateColor(tableData.brake_pads_change_next_days)
              "
            >
              {{ tableData.brake_pads_change_next_date || '—' }}
            </td>
          </tr>
          <tr>
            <td>
              <b>{{ $t('auto.internalMaintenance.coolantReplacement') }}</b>
            </td>
            <td>
              <button
                class="edit-btn"
                :disabled="editDisabled"
                @click="
                  () => {
                    dateDialog.opened = true;
                    dateDialog.currentValue = tableData.coolant_change_date;
                    dateDialog.paramName = 'coolant_change_date';
                  }
                "
              >
                {{ tableData.coolant_change_date || '—' }}
              </button>
            </td>
            <td
              :class="getExpireStateColor(tableData.coolant_change_next_days)"
            >
              {{ tableData.coolant_change_next_date || '—' }}
            </td>
          </tr>
          <tr>
            <td>
              <b>{{ $t('auto.internalMaintenance.brakeFluidReplacement') }}</b>
            </td>
            <td>
              <button
                class="edit-btn"
                :disabled="editDisabled"
                @click="
                  () => {
                    dateDialog.opened = true;
                    dateDialog.currentValue = tableData.brake_fluid_change_date;
                    dateDialog.paramName = 'brake_fluid_change_date';
                  }
                "
              >
                {{ tableData.brake_fluid_change_date || '—' }}
              </button>
            </td>
            <td
              :class="
                getExpireStateColor(tableData.brake_fluid_change_next_days)
              "
            >
              {{ tableData.brake_fluid_change_next_date || '—' }}
            </td>
          </tr>
          <tr>
            <td>
              <b>{{ $t('auto.internalMaintenance.airFiltersReplacement') }}</b>
            </td>
            <td>
              <button
                class="edit-btn"
                :disabled="editDisabled"
                @click="
                  () => {
                    dateDialog.opened = true;
                    dateDialog.currentValue = tableData.air_filter_change_date;
                    dateDialog.paramName = 'air_filter_change_date';
                  }
                "
              >
                {{ tableData.air_filter_change_date || '—' }}
              </button>
            </td>
            <td
              :class="
                getExpireStateColor(tableData.air_filter_change_next_days)
              "
            >
              {{ tableData.air_filter_change_next_date || '—' }}
            </td>
          </tr>
          <tr>
            <td>
              <b>{{ $t('auto.internalMaintenance.transmissionOilChange') }}</b>
            </td>
            <td>
              <button
                class="edit-btn"
                :disabled="editDisabled"
                @click="
                  () => {
                    dateDialog.opened = true;
                    dateDialog.currentValue =
                      tableData.auto_transmission_oil_change_date;
                    dateDialog.paramName = 'auto_transmission_oil_change_date';
                  }
                "
              >
                {{ tableData.auto_transmission_oil_change_date || '—' }}
              </button>
            </td>
            <td
              :class="
                getExpireStateColor(
                  tableData.auto_transmission_oil_change_next_days,
                )
              "
            >
              {{ tableData.auto_transmission_oil_change_next_date || '—' }}
            </td>
          </tr>
          <tr>
            <td>
              <b>{{
                $t('auto.internalMaintenance.manualTransmissionOilChange')
              }}</b>
            </td>
            <td>
              <button
                class="edit-btn"
                :disabled="editDisabled"
                @click="
                  () => {
                    dateDialog.opened = true;
                    dateDialog.currentValue =
                      tableData.manual_transmission_oil_change_date;
                    dateDialog.paramName =
                      'manual_transmission_oil_change_date';
                  }
                "
              >
                {{ tableData.manual_transmission_oil_change_date || '—' }}
              </button>
            </td>
            <td
              :class="
                getExpireStateColor(
                  tableData.manual_transmission_oil_change_next_days,
                )
              "
            >
              {{ tableData.manual_transmission_oil_change_next_date || '—' }}
            </td>
          </tr>
          <tr>
            <td>
              <b>{{
                $t('auto.internalMaintenance.steeringFluidReplacement')
              }}</b>
            </td>
            <td>
              <button
                class="edit-btn"
                :disabled="editDisabled"
                @click="
                  () => {
                    dateDialog.opened = true;
                    dateDialog.currentValue =
                      tableData.steering_oil_change_date;
                    dateDialog.paramName = 'steering_oil_change_date';
                  }
                "
              >
                {{ tableData.steering_oil_change_date || '—' }}
              </button>
            </td>
            <td
              :class="
                getExpireStateColor(tableData.steering_oil_change_next_days)
              "
            >
              {{ tableData.steering_oil_change_next_date || '—' }}
            </td>
          </tr>
          <tr>
            <td>
              <b>{{ $t('auto.internalMaintenance.sparkPlugReplacement') }}</b>
            </td>
            <td>
              <button
                class="edit-btn"
                :disabled="editDisabled"
                @click="
                  () => {
                    dateDialog.opened = true;
                    dateDialog.currentValue = tableData.spark_plugs_change_date;
                    dateDialog.paramName = 'spark_plugs_change_date';
                  }
                "
              >
                {{ tableData.spark_plugs_change_date || '—' }}
              </button>
            </td>
            <td
              :class="
                getExpireStateColor(tableData.spark_plugs_change_next_days)
              "
            >
              {{ tableData.spark_plugs_change_next_date || '—' }}
            </td>
          </tr>
          <tr>
            <td>
              <b>{{ $t('auto.internalMaintenance.fuelFilterReplacement') }}</b>
            </td>
            <td>
              <button
                class="edit-btn"
                :disabled="editDisabled"
                @click="
                  () => {
                    dateDialog.opened = true;
                    dateDialog.currentValue = tableData.fuel_filter_change_date;
                    dateDialog.paramName = 'fuel_filter_change_date';
                  }
                "
              >
                {{ tableData.fuel_filter_change_date || '—' }}
              </button>
            </td>
            <td
              :class="
                getExpireStateColor(tableData.fuel_filter_change_next_days)
              "
            >
              {{ tableData.fuel_filter_change_next_date || '—' }}
            </td>
          </tr>
          <tr>
            <td>
              <b>{{
                $t('auto.internalMaintenance.manualClutchReplacement')
              }}</b>
            </td>
            <td>
              <button
                class="edit-btn"
                :disabled="editDisabled"
                @click="
                  () => {
                    dateDialog.opened = true;
                    dateDialog.currentValue = tableData.clutch_change_date;
                    dateDialog.paramName = 'clutch_change_date';
                  }
                "
              >
                {{ tableData.clutch_change_date || '—' }}
              </button>
            </td>
            <td :class="getExpireStateColor(tableData.clutch_change_next_days)">
              {{ tableData.clutch_change_next_date || '—' }}
            </td>
          </tr>
          <tr>
            <td>
              <b>{{ $t('auto.internalMaintenance.timingBeltReplacement') }}</b>
            </td>
            <td>
              <button
                class="edit-btn"
                :disabled="editDisabled"
                @click="
                  () => {
                    dateDialog.opened = true;
                    dateDialog.currentValue = tableData.timing_belt_change_date;
                    dateDialog.paramName = 'timing_belt_change_date';
                  }
                "
              >
                {{ tableData.timing_belt_change_date || '—' }}
              </button>
            </td>
            <td
              :class="
                getExpireStateColor(tableData.timing_belt_change_next_days)
              "
            >
              {{ tableData.timing_belt_change_next_date || '—' }}
            </td>
          </tr>
          <tr>
            <td>
              <b>{{ $t('auto.internalMaintenance.battery') }}</b>
            </td>
            <td>
              <button
                class="edit-btn"
                :disabled="editDisabled"
                @click="
                  () => {
                    dateDialog.opened = true;
                    dateDialog.currentValue = tableData.battery_change_date;
                    dateDialog.paramName = 'battery_change_date';
                  }
                "
              >
                {{ tableData.battery_change_date || '—' }}
              </button>
            </td>
            <td class="empty-cell">{{ $t('common.no') }}</td>
          </tr>
          <tr>
            <td>
              <b>{{ $t('auto.internalMaintenance.radiator') }}</b>
            </td>
            <td>
              <button
                class="edit-btn"
                :disabled="editDisabled"
                @click="
                  () => {
                    dateDialog.opened = true;
                    dateDialog.currentValue = tableData.radiator_change_date;
                    dateDialog.paramName = 'radiator_change_date';
                  }
                "
              >
                {{ tableData.radiator_change_date || '—' }}
              </button>
            </td>
            <td class="empty-cell">{{ $t('common.no') }}</td>
          </tr>
          <tr>
            <td>
              <b>{{ $t('auto.internalMaintenance.grenade') }}</b>
            </td>
            <td>
              <button
                class="edit-btn"
                :disabled="editDisabled"
                @click="
                  () => {
                    dateDialog.opened = true;
                    dateDialog.currentValue = tableData.grenade_change_date;
                    dateDialog.paramName = 'grenade_change_date';
                  }
                "
              >
                {{ tableData.grenade_change_date || '—' }}
              </button>
            </td>
            <td class="empty-cell">{{ $t('common.no') }}</td>
          </tr>
          <tr>
            <td>
              <b>{{ $t('auto.internalMaintenance.hubBearing') }}</b>
            </td>
            <td>
              <button
                class="edit-btn"
                :disabled="editDisabled"
                @click="
                  () => {
                    dateDialog.opened = true;
                    dateDialog.currentValue = tableData.hub_bearing_change_date;
                    dateDialog.paramName = 'hub_bearing_change_date';
                  }
                "
              >
                {{ tableData.hub_bearing_change_date || '—' }}
              </button>
            </td>
            <td class="empty-cell">{{ $t('common.no') }}</td>
          </tr>
          <tr>
            <td>
              <b>{{ $t('auto.internalMaintenance.fuelPump') }}</b>
            </td>
            <td>
              <button
                class="edit-btn"
                :disabled="editDisabled"
                @click="
                  () => {
                    dateDialog.opened = true;
                    dateDialog.currentValue = tableData.fuel_pump_change_date;
                    dateDialog.paramName = 'fuel_pump_change_date';
                  }
                "
              >
                {{ tableData.fuel_pump_change_date || '—' }}
              </button>
            </td>
            <td class="empty-cell">{{ $t('common.no') }}</td>
          </tr>
          <tr>
            <td>
              <b>{{ $t('auto.internalMaintenance.generatorBelt') }}</b>
            </td>
            <td>
              <button
                class="edit-btn"
                :disabled="editDisabled"
                @click="
                  () => {
                    dateDialog.opened = true;
                    dateDialog.currentValue =
                      tableData.generator_belt_change_date;
                    dateDialog.paramName = 'generator_belt_change_date';
                  }
                "
              >
                {{ tableData.generator_belt_change_date || '—' }}
              </button>
            </td>
            <td class="empty-cell">{{ $t('common.no') }}</td>
          </tr>
          <tr>
            <td>
              <b>{{ $t('auto.internalMaintenance.starter') }}</b>
            </td>
            <td>
              <button
                class="edit-btn"
                :disabled="editDisabled"
                @click="
                  () => {
                    dateDialog.opened = true;
                    dateDialog.currentValue = tableData.starter_change_date;
                    dateDialog.paramName = 'starter_change_date';
                  }
                "
              >
                {{ tableData.starter_change_date || '—' }}
              </button>
            </td>
            <td class="empty-cell">{{ $t('common.no') }}</td>
          </tr>
          <tr>
            <td>
              <b>{{ $t('auto.internalMaintenance.tip') }}</b>
            </td>
            <td>
              <button
                class="edit-btn"
                :disabled="editDisabled"
                @click="
                  () => {
                    dateDialog.opened = true;
                    dateDialog.currentValue = tableData.tip_change_date;
                    dateDialog.paramName = 'tip_change_date';
                  }
                "
              >
                {{ tableData.tip_change_date || '—' }}
              </button>
            </td>
            <td class="empty-cell">{{ $t('common.no') }}</td>
          </tr>
          <tr>
            <td>
              <b>{{ $t('auto.internalMaintenance.collapseConvergence') }}</b>
            </td>
            <td>
              <button
                class="edit-btn"
                :disabled="editDisabled"
                @click="
                  () => {
                    dateDialog.opened = true;
                    dateDialog.currentValue =
                      tableData.collapse_convergence_change_date;
                    dateDialog.paramName = 'collapse_convergence_change_date';
                  }
                "
              >
                {{ tableData.collapse_convergence_change_date || '—' }}
              </button>
            </td>
            <td class="empty-cell">{{ $t('common.no') }}</td>
          </tr>
          <tr>
            <td>
              <b>{{ $t('auto.internalMaintenance.barrelAntifreeze') }}</b>
            </td>
            <td>
              <button
                class="edit-btn"
                :disabled="editDisabled"
                @click="
                  () => {
                    dateDialog.opened = true;
                    dateDialog.currentValue =
                      tableData.barrel_antifreeze_change_date;
                    dateDialog.paramName = 'barrel_antifreeze_change_date';
                  }
                "
              >
                {{ tableData.barrel_antifreeze_change_date || '—' }}
              </button>
            </td>
            <td class="empty-cell">{{ $t('common.no') }}</td>
          </tr>
        </tbody>
      </v-simple-table>
    </v-flex>

    <v-snackbar v-model="snack.opened" :color="snack.color" bottom right>
      {{ snack.message }}
    </v-snackbar>

    <maintenance-date-dialog
      v-model="dateDialog.opened"
      :param-name="dateDialog.paramName"
      :current-value="dateDialog.currentValue"
      :item-id="tableData.id"
      @update="proccessResult"
    />
  </v-layout>
</template>

<script>
import MaintenanceDateDialog from '@/components/auto/MaintenanceDateDialog.vue';

export default {
  data: () => ({
    dateDialog: {
      opened: false,
      loading: false,
      paramName: '',
      currentValue: '',
    },
    snack: {
      opened: false,
      message: '',
      color: '',
    },
  }),
  components: { MaintenanceDateDialog },
  computed: {
    autoTitle() {
      return this.$store.getters['auto/getAutoTitle'];
    },
    headers() {
      return [
        { text: this.$t('auto.internalMaintenance.type'), sortable: false },
        { text: this.$t('auto.replacementDate'), sortable: false },
        { text: this.$t('auto.nextReplacementDate'), sortable: false },
      ];
    },
    tableData() {
      return this.$store.state.auto.internalMaintenance.list[0] || {};
    },
    editDisabled() {
      return !this.$can('auto_internal_maintenance_edit');
    },
  },
  methods: {
    async fetchList() {
      this.loading = true;

      await this.$store.dispatch('auto/fetchInternalMaintenance', {
        car_id: this.$route.params.autoId,
      });

      this.loading = false;
    },
    proccessResult({ success }) {
      const snack = {
        opened: true,
        message: this.$t('common.saved'),
        color: 'success',
      };

      if (success) {
        this.fetchList();
      } else {
        snack.message = this.$t('common.errors.APIerror');
        snack.color = 'error';
      }

      this.snack = snack;
    },
    getExpireStateColor(days) {
      const noData = !days && days !== 0;
      if (noData || days > 15) return '';

      if (days > 10) return 'green lighten-4';
      if (days > 0) return 'yellow lighten-4';

      return 'red lighten-4';
    },
  },
  created() {
    this.fetchList();
  },
};
</script>

<style lang="scss">
.edit-btn {
  text-align: left;
  font-size: 14px;
  font-weight: 600;
  color: #464646;
  line-height: 1.3;
  text-decoration: none;

  &[disabled] {
    font-weight: normal;
  }

  &:not([disabled]):hover {
    opacity: 0.7;
  }
}
</style>
